import ViewViewModel from '@/ViewModels/ViewViewModel';
import ComponentManager from '@/Management/ComponentManager';
import * as CoreFrameInterfaces from '#/CoreFrameInterfaces';

export default class DebugViewModel extends ViewViewModel {

    public constructor(params: CoreFrameInterfaces.DebugViewModelConstructorParameter) {
        super(params);
    }
}

ComponentManager.setViewModel('DebugViewModel', DebugViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');